import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";

import { navigateToRoleDashboard } from "../../../../system";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigateToRoleDashboard(navigate);
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-4 text-center"
      data-testid="unauthorized-page"
    >
      <h1 className="mb-3">Unauthorized</h1>
      <p className="mb-4 text-muted">
        You do not have permission to view this page.
      </p>
      <Button variant="primary" onClick={goToDashboard}>
        Go to Dashboard
      </Button>
    </div>
  );
};

export default Unauthorized;
